<script>
export default {
  props: {
    onParameterDefinitionClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
